<template>
  <main class="main-content">
    <div class="Second-main-content">
      <div class="role-creation-page">
        <div class="back-navigation">
          <button class="back-button">
            <i class="icon-chevron-left"></i>
            Back to Previous Page
          </button>
        </div>
        <div class="form-container">
          <div class="section-header">
            <h2>Akiba Halisi Plan</h2>
          </div>
          <div class="create-role-section">
            <div class="form-row">
              <div class="form-group">
                <label for="roleName">Product Name</label>
                <input
                  type="text"
                  id="roleName"
                  v-model="productName"
                  placeholder="Product Name"
                />
              </div>
              <div class="form-group">
                <label for="description">Description</label>
                <input
                  type="text"
                  id="description"
                  v-model="description"
                  placeholder="This the product's description"
                />
              </div>
            </div>
          </div>
          <div class="permissions-section">
            <div class="product-section">
              <h4>Product Interest</h4>
              <div class="permissions-row">
                <div class="toggle-column">
                  <label for="switchOption" class="switch-label">Switch option</label>
                  <div class="switch">
                    <input id="switchOption" type="checkbox" v-model="interestActive">
                    <span class="slider round"></span>
                  </div>
                </div>
                <div class="rates-column">
                  <div class="rate-inputs">
                    <div class="rate-input">
                      <label for="defaultInterest">Default Interest Rate</label>
                      <div class="percentage-input">
                        <input id="defaultInterest" type="text" v-model="interestDefaultRate" :disabled="!interestActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                    <div class="rate-input">
                      <label for="minimumInterest">Minimum Interest Rate</label>
                      <div class="percentage-input">
                        <input id="minimumInterest" type="text" v-model="interestMinRate" :disabled="!interestActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                    <div class="rate-input">
                      <label for="maximumInterest">Maximum Interest Rate</label>
                      <div class="percentage-input">
                        <input id="maximumInterest" type="text" v-model="interestMaxRate" :disabled="!interestActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-section">
              <h4>Revisionary Bonus</h4>
              <div class="permissions-row">
                <div class="toggle-column">
                  <label for="revisionaryBonusSwitch" class="switch-label">Switch option</label>
                  <div class="switch">
                    <input id="revisionaryBonusSwitch" type="checkbox" v-model="revisionaryBonusActive">
                    <span class="slider round"></span>
                  </div>
                </div>
                <div class="rates-column">
                  <div class="rate-inputs">
                    <div class="rate-input">
                      <label for="defaultInterestRate">Default Interest Rate</label>
                      <div class="percentage-input">
                        <input id="defaultInterestRate" type="text" v-model="revisionaryDefaultRate" :disabled="!revisionaryBonusActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                    <div class="rate-input">
                      <label for="minimumInterestRate">Minimum Interest Rate</label>
                      <div class="percentage-input">
                        <input id="minimumInterestRate" type="text" v-model="revisionaryMinRate" :disabled="!revisionaryBonusActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                    <div class="rate-input">
                      <label for="maxInterest">Maximum Interest Rate</label>
                      <div class="percentage-input">
                        <input id="maxInterest" type="text" v-model="revisionaryMaxRate" :disabled="!revisionaryBonusActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-section">
              <h4>Terminal Bonus</h4>
              <div class="permissions-row">
                <div class="toggle-column">
                  <label for="terminalBonusSwitch" class="switch-label">Switch option</label>
                  <div class="switch">
                    <input id="terminalBonusSwitch" type="checkbox" v-model="terminalBonusActive">
                    <span class="slider round"></span>
                  </div>
                </div>
                <div class="rates-column">
                  <div class="rate-inputs">
                    <div class="rate-input">
                      <label for="terminalDefaultRate">Default Interest Rate</label>
                      <div class="percentage-input">
                        <input id="terminalDefaultRate" type="text" v-model="terminalDefaultRate" :disabled="!terminalBonusActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                    <div class="rate-input">
                      <label for="terminalMinRate">Minimum Interest Rate</label>
                      <div class="percentage-input">
                        <input id="terminalMinRate" type="text" v-model="terminalMinRate" :disabled="!terminalBonusActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                    <div class="rate-input">
                      <label for="terminalMaxRate">Maximum Interest Rate</label>
                      <div class="percentage-input">
                        <input id="terminalMaxRate" type="text" v-model="terminalMaxRate" :disabled="!terminalBonusActive">
                        <span class="percentage-sign">%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="action-buttons-container">
              <button class="btn-cancel" @click="cancel">Cancel</button>
              <button class="btn-save" @click="saveRole">Save & Update Details</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'ProductSetup',
  data() {
    return {
      productName: 'Akiba halisi plan 2',
      roleName: '',
      description: '',

      interestActive: false,
      interestDefaultRate: '',
      interestMinRate: '',
      interestMaxRate: '',

      revisionaryBonusActive: false,
      revisionaryDefaultRate: '',
      revisionaryMinRate: '',
      revisionaryMaxRate: '',

      terminalBonusActive: false,
      terminalDefaultRate: '',
      terminalMinRate: '',
      terminalMaxRate: '',
    };
  },
  methods: {
    cancel() {
    },
    saveRole() {
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.second-main-content {
  flex: 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: #f0f2f5;
}

.role-creation-page {
  background-color: #f5f7fa;
  padding: 24px;
  font-family: Arial, sans-serif;
  color: #333;
}

.back-navigation {
  margin-bottom: 16px;
}

.back-button {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  color: #2563eb;
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
}

.icon-chevron-left::before {
  content: '←';
  margin-right: 8px;
}

.form-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  max-width: 1000px;
  margin: 0 auto;
}

.section-header {
  padding: 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}

.section-header h2 {
  font-size: 18px;
  font-weight: 500;
  color: #374151;
}

.create-role-section {
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.create-role-section h3 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #111827;
}

.subtitle {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #374151;
}

.form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

/* Permissions section */
.permissions-section {
  padding: 24px;
}

.permissions-section h3 {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 4px;
  color: #111827;
}

.product-section {
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.product-section h4 {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
  color: #374151;
}

.permissions-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 32px;
  align-items: center;
}

.toggle-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.switch-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
  font-weight: 500;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2563eb;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2563eb;
}

input:checked + .slider:before {
  transform: translateX(24px);
}

.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Rate inputs */
.rates-column {
  width: 100%;
}

.rate-inputs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.rate-input {
  display: flex;
  flex-direction: column;
}

.rate-input label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
  font-weight: 500;
}

.percentage-input {
  position: relative;
}

.percentage-input input {
  width: 100%;
  padding: 8px 24px 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
}

.percentage-sign {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6b7280;
}

.action-buttons-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
}

.btn-cancel {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  background-color: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #4b5563;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-save {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  background-color: #2563eb;
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-cancel:hover {
  background-color: #f3f4f6;
}

.btn-save:hover {
  background-color: #1d4ed8;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .rate-inputs {
    grid-template-columns: 1fr;
  }

  .permissions-row {
    grid-template-columns: 1fr;
  }
}

.main-content {
  flex: 1;
  padding: 1.5rem 2rem;
  overflow-y: auto;
  background-color: #f0f2f5;
  margin-left: 220px;
}
</style>
